export class Shipyard {
    id: number;
    name: string;
}
